import React, { useEffect, useState } from 'react';
import VerifyCode from '../../components/form/VerifyCode';
import Alert from 'react-bootstrap/Alert';
import { executeRecaptchaEnterprise } from '../../utils/recaptcha';
import { CREATE_BOOKING_INTENTION, SEND_CODE } from '../../utils/endpoints';
import { useSnackbar } from 'notistack';
import { cooperationLogin } from './utils/cooperationUtils';
import { useRouter } from 'next/router';

function VerifyPhone(props) {
  const router = useRouter();
  const [seconds, setSeconds] = useState(60);
  const [error, setError] = useState('');
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    let interval = null;
    if (seconds > 0) {
      interval = setInterval(() => {
        setSeconds(seconds - 1);
      }, 1000);
    } else if (seconds === 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [seconds]);

  const onSubmit = async (code) => {
    try {
      const data = await cooperationLogin(
        props.phone,
        code,
        props.countryCode,
        props.cooperation
      );
      if (data?.status === true) {
        const res = await fetch(CREATE_BOOKING_INTENTION, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${data.data.token}`,
          },
          body: JSON.stringify(props.formValues),
        });
        if (res.ok) {
          router.push(
            '/[cooperation]/success',
            `/${props.cooperation}/success`
          );

          enqueueSnackbar('تم إرسال الطلب بنجاح', {
            variant: 'success',
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });

          const json = await res.json();
          if (json.status === true) {
          } else {
            setError(json.error);
          }
        }
      } else {
        enqueueSnackbar(data?.error, {
          variant: 'error',
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
        setError(data?.error);
      }
    } catch (error) {
      console.log('error', error);
      setError(error.error);
    }
  };

  const resend = async (e) => {
    e.preventDefault();
    const token = await executeRecaptchaEnterprise('sms_verification');
    const api_payload = {
      country_code: props.countryCode,
      phone: props.phone,
      'g-token': token,
    };

    await fetch(SEND_CODE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(api_payload),
    });

    setSeconds(60);
  };

  const changeNumber = () => {
    props.setFormStep(1);
  };

  return (
    <div>
      <div className="text-center text-dark d-flex flex-column justify-content-center align-items-center">
        <h3
          style={{ fontSize: 18, direction: 'rtl' }}
          className="mb-4 text-center"
        >
          <span>أدخل الرمز المرسل إلى الرقم</span>
          <br />
          <span
            style={{
              color: 'rgb(243,84,39)',
              marginTop: 10,
              fontSize: 16,
              display: 'inline-block',
              direction: 'ltr',
            }}
          >
            +{props.countryCode} {props.phone}
          </span>
          <span
            role="button"
            onClick={changeNumber}
            style={{
              fontSize: 16,
              marginRight: 5,
              display: 'inline-block',
              direction: 'ltr',
              color: 'rgb(243,84,39)',
              textDecoration: 'underline',
            }}
          >
            ( عدل الرقم )
          </span>
        </h3>
        <div className="w-100 d-flex flex-column">
          <VerifyCode
            onComplete={onSubmit}
            loading={props.onProgress === 'VERIFY_PHONE'}
            error={props.error}
            className="marketing__verify-code"
          />
          {!!seconds && (
            <div
              style={{
                display: 'flex',
                gap: '0.8rem',
                justifyContent: 'center',
                marginTop: 30,
              }}
            >
              <p>لقد تم إرسال رمز إلى هاتفك</p>
              <div
                style={{
                  color: 'rgb(243,84,39)',
                }}
              >
                <p>
                  <span>{seconds}</span>:<span>00</span>
                </p>
              </div>
            </div>
          )}
          {!seconds && (
            <>
              <div style={{ marginTop: 10, marginBottom: 10 }}>
                لم تصلك الرسالة بعد؟
              </div>
              <button onClick={resend} className="login-btn">
                أعد الإرسال
              </button>
            </>
          )}
          {error && (
            <Alert variant="danger" className="mt-3">
              {error}
            </Alert>
          )}
        </div>
      </div>
    </div>
  );
}

export default VerifyPhone;
